import React from "react";

const Error = () => {
  return (
    <div className="error-container">
      <h2 className="error-message">Check out the world map to add breads to your breadBox!</h2>
    </div>
  );
}

export default Error;
